import { toggleBackgroundEffect } from 'jitsi/virtual-background/actions';
// @ts-ignore
import { jitsiLocalStorage } from '@jitsi/js-utils/jitsi-local-storage';
// @ts-ignore
import { toDataUrl } from 'jitsi/base/tracks/functions.web';
const ROOM_TYPES = {
    CONFERENCE_ROOM: 1,
    IND_VIRTUAL_OFFICE: 2,
    ORG_VIRTUAL_OFFICE: 3,
    TEMPORARY_ROOM: 4,
};
const setVirtualBackgrounds = (images) => {
    jitsiLocalStorage.setItem('virtualBackgrounds', JSON.stringify(images));
};
export const loadVirtualBackgroundOptions = async (state, dispatch) => {
    const virtualBackground = state['features/virtual-background'];
    const { room, user, isModerator, isBackgroundApplied } = window.APP || {};
    const userBackgroundImage = room?.conference_options?.user_background_image;
    const localImages = jitsiLocalStorage.getItem('virtualBackgrounds');
    const storedImages = (localImages && JSON.parse(localImages)) || [];
    const exist = storedImages.find((image) => image.id === 'custom');
    const isVconnectCallee = room?.vconnect && !room.vconnectCaller && isModerator;
    const isVconnectCaller = room?.vconnect && room.vconnectCaller;
    const isOrgVirtualOffice = room?.room_type == ROOM_TYPES.ORG_VIRTUAL_OFFICE;
    let newSettings = {};
    if ((isVconnectCallee && room?.conference_options?.user_background_blur) ||
        (isVconnectCaller && room.isBackgroundBlur)) {
        window.APP.isBackgroundApplied = true;
        newSettings = {
            backgroundEffectEnabled: true,
            backgroundType: 'blur',
            blurValue: 25,
            selectedThumbnail: 'blur',
        };
    }
    else if (isVconnectCallee && userBackgroundImage) {
        window.APP.isBackgroundApplied = true;
        newSettings = {
            backgroundEffectEnabled: true,
            backgroundType: 'image',
            virtualSource: userBackgroundImage,
        };
    }
    else if (userBackgroundImage &&
        !isBackgroundApplied &&
        ((isOrgVirtualOffice && isModerator) ||
            (!isOrgVirtualOffice &&
                user?.email &&
                user?.memberships.some((membership) => membership.id === room?.organisation_id)))) {
        window.APP.isBackgroundApplied = true;
        const result = await toDataUrl(userBackgroundImage);
        newSettings = {
            backgroundEffectEnabled: true,
            backgroundType: 'image',
            virtualSource: result,
            selectedThumbnail: '',
        };
        if (storedImages && !exist) {
            setVirtualBackgrounds([...storedImages, { id: 'custom', src: result }]);
        }
    }
    else if (!window.APP?.isBackgroundApplied && exist) {
        setVirtualBackgrounds(storedImages.filter((image) => image.id !== 'custom'));
    }
    dispatch(toggleBackgroundEffect({ ...virtualBackground, ...newSettings }));
};
